<template>
    <v-container fluid tag="section">
        <material-card color="primary" icon="mdi-credit-card">
            <template #title>
                Банківський продукт
            </template>

            <ButtonComeBack class="ml-3 mb-3" />
            <v-col cols="12" lg="6">
                <v-form lazy-validation v-model="isValidForm" ref="form">
                    <v-row>
                        <!--Проекти-->
                        <v-col cols="12">
                            <v-switch v-model="bank.enabled" label="Включено"></v-switch>
                        </v-col>
                        <!-- Код товару -->
                        <v-col cols="12">
                            <v-text-field label="Код typhoon товару" v-model="bank.typhoon_id" readonly />
                        </v-col>
                        <!-- Назва -->
                        <v-col cols="12">
                            <v-text-field label="Назва" v-model="bank.name" readonly />
                        </v-col>
                        <!-- Назва банку select-->
                        <v-col cols="12">
                            <v-select return-object item-text="name" item-value="id" v-model="bank.bank_id"
                                :items="banks" label="Банк" required :rules="[v => !!v || errorRequired]" />
                        </v-col>
                        <!-- Банківський продукт select-->
                        <v-col cols="12">
                            <v-select return-object item-text="name" item-value="id" v-model="bank.bank_product_id"
                                :items="bankProducts" label="Банківський продукт" required
                                :rules="[v => !!v || errorRequired]" />
                        </v-col>
                        <!-- Проєкт select-->
                        <v-col cols="12">
                            <v-select return-object item-text="name" item-value="id" v-model="bank.project_id"
                                :items="projects" label="Проект" required :rules="[v => !!v || errorRequired]" />
                        </v-col>
                    </v-row>


                    <!--Кнопки-->
                    <v-col cols="12" class="text-right">
                        <v-btn color="primary" min-width="150" @click="sendForm()">
                            Зберегти
                        </v-btn>
                    </v-col>
                    <Preloader v-if="isSending" />
                </v-form>
            </v-col>

        </material-card>
    </v-container>
</template>

<script>
import { HTTP } from '@/http-common';
import { mapGetters, mapMutations, mapActions } from 'vuex';

export default {
    name: 'PageBankAdd',
    props: {
        id: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            bank: {
                id: null,
                enabled: true,
                typhoon_id: '',
                bank_id: null,
                bank_product_id: null,
                project_id: null,
                name: '',
            },
            bankData: [],
            bankProducts: [],
            banks: [],
            // Активный таб
            tab: 0,
            isValidForm: true,
            errorRequired: `Це поле обов'язкове`,
            isSending: false,
        }
    },
    computed: {
        ...mapGetters(['snackbar', 'isAdmin', 'isManager', 'projects']),
    },
    mounted() {
        this.init();
    },

    methods: {
        ...mapMutations(['setSnackbar']),
        ...mapActions(['getProjects']),
        // Подготовка данных
        async init() {
            await this.getProjects();
            await this.getBanks();
            await this.getBankProducts();
            if (this.id) {
                const bankData = await HTTP.post('/get-bank-credit-for-goods', { id: this.id });
                this.bankData = bankData.data.content;
                const d = this.bankData;
                this.bank = {
                    id: this.id,
                    enabled: d[0].enabled,
                    typhoon_id: d[0].typhoon_id,
                    bank_id: d[0].bank_id,
                    bank_product_id: d[0].bank_product_id,
                    project_id: d[0].project_id,
                    name: d[0].name,
                };
            } else {
                this.bank = {
                    id: null,
                    enabled: true,
                    typhoon_id: this.$route.query.typhoon_id || '',
                    bank_id: null,
                    bank_product_id: null,
                    project_id: null,
                    name: this.$route.query.name || '',
                };
            }
        },
        async getBanks() {
            let { page = 1 } = this.$route.query;
            this.pageCurrent = +page;

            try {
                let { data } = await HTTP.post('/get-list-banks', {
                    limit: 100,
                    page,
                });

                this.banks = data?.content?.data || [];
                this.pagesCount = data?.content?.pagination?.pages || 1;
            } catch (error) {
                console.warn(error);
            }
        },
        async getBankProducts() {
            try {
                let { data } = await HTTP.post('/get-list-bank-product', {
                    // bank: this.bank?.id,
                });

                this.bankProducts = data?.content?.data || [];
            } catch (error) {
                console.warn(error);
            }
        },

        // Отправка формы
        async sendForm() {
            this.errorDate = '';

            if (!this.$refs.form.validate()) {
                return;
            };

            this.isSending = true;

            try {
                if (this.id) {
                    await HTTP.post("/update-bank-credit-for-goods", {
                        id: this.id,
                        ...this.bank,
                        bank_product_id: this.bank.bank_product_id?.id || this.bank.bank_product_id,
                        bank_id: this.bank.bank_id?.id || this.bank.bank_id,
                        project_id: this.bank.project_id?.id || this.bank.project_id,
                    });
                    this.setSnackbar({ type: 'success', text: 'Успiшно збережено' });
                    this.isSending = false;
                } else {
                    let { data } = await HTTP.post("/create-bank-credit-for-goods", {
                        ...this.bank,
                        bank_product_id: this.bank.bank_product_id?.id || this.bank.bank_product_id,
                        bank_id: this.bank.bank_id?.id || this.bank.bank_id,
                        project_id: this.bank.project_id?.id || this.bank.project_id,
                    });
                    this.setSnackbar({ type: 'success', text: 'Успiшно збережено' });
                    this.$router.push(`/bank-credit-for-goods/${data.content.id}/`);
                }
            } catch (error) {
                console.warn(error);
                this.setSnackbar({ type: 'error', text: error?.response?.data?.message || 'Помилка сервера' });
                this.isSending = false;
            }
        },

    },
}
</script>

<style scoped lang="sass">
.form-bank-add
  position: relative
</style>
